<template>
  <footer id="gel-footer" role="footer" class="d-flex justify-content-between px-3 bg-white">
    <span>
      <a
        class="link-alt mr-3"
        target="_blank"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Slack"
        href="https://pageup.slack.com/messages/C2X8J0V70/team/"
      >
        <i aria-hidden="true" class="gel-icon-slack" title="Slack"></i>
      </a>
      <a
        class="link-alt"
        data-toggle="tooltip"
        data-placement="top"
        target="_blank"
        href="https://github.com/PageUpPeopleOrg/gel-website"
        data-original-title="Github"
      >
        <i class="gel-icon-github" aria-hidden="true"></i>
      </a>
    </span>
    <span>
      Design by DUX team 2021
      <a target="_blank" href="https://www.pageuppeople.com/">PageUp</a>
    </span>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style>
</style>